import { createSlice } from '@reduxjs/toolkit';
import { interactiveCreate, interactiveStart } from '../actions/actions';

const interpolation = createSlice({
  name: 'interpolation',
  initialState: {},
  reducers: {
    addInterpolation(state, { payload: { key, value } }) {
      state[key] = value;
    },
    removeInterpolation(state, { payload: { key } }) {
      delete state[key];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(interactiveCreate, (state, action) => {
      state['user_id'] = action.payload?.user_info?.user_id;
    });
    builder.addCase(interactiveStart, (state, action) => {
      const {
        video_id,
        root_id,
        channel_id,
        virtual_id,
        content_type,
      } = action.payload ?? {};

      state['video.id'] = video_id;
      state['video.root_id'] = root_id ?? video_id;
      state['channel.id'] = channel_id;
      state['video.virtual_id'] = virtual_id;
      state['video.type'] = content_type;
    })
  },
});

export const interpolationSelector = (state) => state.interpolation;
export const { addInterpolation, removeInterpolation } = interpolation.actions;
export default interpolation.reducer;
